export default __webpack_public_path__ + "static/media/onboardingLogo.5fcf2522.png";